export const wordPluralize = (
  count: number,
  noun: string,
  suffix = 's',
): string => `${noun}${count !== 1 ? suffix : ''}`;

export const formatString = (format: string, ...args: any[]): string => {
  let i = 0;
  return format.replace(/%[sdifjoO%]/g, (match) => {
    if (match === '%%') {
      return '%';
    }

    if (i >= args.length) {
      return match;
    }

    const arg = args[i++];

    switch (match) {
      case '%s':
        return String(arg);
      case '%d':
      case '%i':
        return parseInt(arg, 10).toString();
      case '%f':
        return parseFloat(arg).toString();
      case '%j':
        return JSON.stringify(arg);
      case '%o':
      case '%O':
        return typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
      default:
        return match;
    }
  });
};

